import { PublicClientApplication } from "@azure/msal-browser";
import axios from "axios";

let msalInstance = null;


export const initMsal = async (userTokenKey) => {

  const response = await axios.get(
    `${process.env.VUE_APP_API}/user-meetings-keys/get/?Key=${userTokenKey}`
  );

  if (response.data.status !== 200) {
    throw new Error("API failed");
  }

  const teamsProvider = response.data.data.find(
    (item) => item.title === "Teams"
  );

  if (!teamsProvider) {
    throw new Error("Teams provider not found");
  }

  const clientId = teamsProvider.value.access_key;
  const tenantId = teamsProvider.value.secret_key;

  const msalConfig = {
    auth: {
      clientId,
      authority: `https://login.microsoftonline.com/${tenantId}`,
      redirectUri: `${process.env.VUE_APP_FRONTEND_DOMAIN}/login`,
    },
    cache: {
      cacheLocation: "localStorage",
      storeAuthStateInCookie: false,
    },
  };

  if (!msalInstance) {
    msalInstance = new PublicClientApplication(msalConfig);
    await msalInstance.initialize();

    await msalInstance.handleRedirectPromise();
  }

  return msalInstance;
};

export const getMsalInstance = () => {
  if (!msalInstance) {
    throw new Error("MSAL not initialized. Call initMsal() first.");
  }
  return msalInstance;
};
